<template>
  <DeviceDetail :is-edit="false"/>
</template>

<script>
import DeviceDetail from './detail';

export default {
  name: "DeviceCreate",
  components: { DeviceDetail },
}
</script>

<style scoped>

</style>
